import { render, staticRenderFns } from "./CommodityAutocomplete.vue?vue&type=template&id=4b2f65f5"
import script from "./CommodityAutocomplete.vue?vue&type=script&lang=js"
export * from "./CommodityAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports